import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatExpensesAreYouClaimingFor: [],

    // Doctor Visit fields
    doctorVisitTelemedicine: '',
    doctorVisitByPhone: false,
    doctorVisitInPerson: false,
    doctorVisitFirstVisit: '',
    doctorVisitFollowUp: '',
    doctorVisitFollowUpFracture: '',
    infoOutpatientPhysicianFeesItems: [],
    infoFollowUpVisitItems: [],
    infoTelemedicineItems: [],
    infoFollowUpFractureItems: [],

    // Diagnostic Tests
    infoDiagnosticTestsItems: [],

    // Prescription Drugs
    infoPrescriptionDrugsItems: [],

    // Ambulance Services
    ambulanceGroundService: '',
    ambulanceAirService: '',
    infoGroundAmbulanceItems: [],
    infoAirAmbulanceItems: [],
    infoOtherAmbulanceItems: [],

    // Hospitalization
    hospitalizationHospitalFees: false,
    hospitalizationInpatientPhysicianFees: false,
    hospitalizationXrayLabsDiagnostics: false,
    hospitalizationEmergencyAirTransportation: false,
    hospitalizationAirfareReturnHome: false,
    hospitalizationFamilyTransportation: false,
    hospitalizationFamilyTransportationMealsAccommodation: false,
    hospitalizationMedicalAttendant: false,
    hospitalizationReturnOfTravellingCompanion: false,
    hospitalizationReturnOfDependentChildren: false,
    hospitalizationHospitalAllowance: false,
    hospitalizationOutOfPocketExpenses: false,
    hospitalizationChildcare: false,
    hospitalizationReturnOfVehicle: false,
    hospitalizationOtherRelated: false,
    infoHospitalFeesItems: [],
    infoInpatientPhysicianFeesItems: [],
    infoXrayLabsDiagnosticsItems: [],
    infoEmergencyAirTransportationItems: [],
    infoAirfareReturnHomeItems: [],
    infoFamilyTransportationItems: [],
    infoFamilyTransportationMealsAccommodationItems: [],
    infoMedicalAttendantItems: [],
    infoReturnOfTravellingCompanionItems: [],
    infoReturnOfDependentChildrenItems: [],
    infoHospitalAllowanceItems: [],
    infoOutOfPocketExpensesItems: [],
    infoChildcareItems: [],
    infoReturnOfVehicleItems: [],
    returnOfVehicleCommercialAgency: false,
    returnOfVehicleFamilyMemberFriend: false,
    infoReturnOfVehicleCommercialAgencyItems: [],
    infoReturnOfVehicleFamilyMemberFriendItems: [],
    infoOtherHospitalizationItems: [],

    // Essential Medical Equipment
    infoEssentialMedicalEquipmentItems: [],

    // Private Duty Nursing
    infoPrivateDutyNursingItems: [],

    // Fracture Treatment
    infoFractureTreatmentItems: [],

    // Accidental Death and Dismemberment Benefits
    infoAccidentalDeathAndDismembermentItems: [],

    // Expenses Related to Death
    expensesRelatedToDeathReturnRemains: false,
    expensesRelatedToDeathBurialCremation: false,
    expensesRelatedToDeathFamilyTransportation: false,
    infoExpensesRelatedToDeathReturnRemainsItems: [],
    infoExpensesRelatedToDeathBurialCremationItems: [],
    infoExpensesRelatedToDeathFamilyTransportationItems: [],

    // Maternity Benefits
    maternityBenefitsDateOfConception: '',
    maternityBenefitsAnticipatedDueDate: '',
    maternityBenefitsRoutinePreNatalCare: false,
    maternityBenefitsComplicationsOfPregnancy: false,
    infoRoutinePreNatalCareItems: [],
    infoComplicationsOfPregnancyItems: [],

    // Dental Services
    dentalServicesDentalAccident: false,
    dentalServicesDentalPainOther: false,
    infoDentalAccidentItems: [],
    infoDentalPainOtherItems: [],

    // Professional Services
    professionalServices: false,
    professionalServicesPhysiotherapist: false,
    professionalServicesChiropractor: false,
    professionalServicesChiropodist: false,
    professionalServicesOsteopath: false,
    professionalServicesPodiatrist: false,
    professionalServicesAcupuncturist: false,
    professionalServicesOptometrist: false,
    infoPhysiotherapistItems: [],
    infoChiropractorItems: [],
    infoChiropodistItems: [],
    infoOsteopathItems: [],
    infoPodiatristItems: [],
    infoAcupuncturistItems: [],
    infoOptometristItems: [],

    // Other (unrelated to any benefit listed above)
    infoOtherUnrelatedBenefitItems: [],
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  let newState = state;
  fields.forEach((field) => {
    const defaultValue = initialState.getIn(['form', field]);
    newState = newState.setIn(['form', field], defaultValue);
  });

  return newState;
}

function standardVTCMedicalBenefitsTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default standardVTCMedicalBenefitsTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StandardVTCMedicalBenefits/reducer.js